const o = "darkMode", t = "lightMode", _ = "stennHub", d = {
  Thin: 100,
  "Extra Light": 200,
  Light: 300,
  Regular: 400,
  Medium: 500,
  SemiBold: 600,
  "Semi Bold": 600,
  Bold: 700,
  "Extra Bold": 800,
  Black: 900
};
export {
  d as FONT_WEIGHT_MAPPING,
  o as JSON_KEY_DARK,
  t as JSON_KEY_LIGHT,
  _ as JSON_KEY_STENN_HUB
};
//# sourceMappingURL=constants29.mjs.map
